export const getGoogleAnalysticsID = () => {
    if (typeof window === 'undefined') return null
    if (window.location.hostname === 'localhost') return null
    return 'UA-140885983-1'
}
